module.exports = __webpack_public_path__ + "static/media/142bf7fe2b88ca521d02397f88943325_html_1e49bc8762800abb.632efd78.png";